import { render, staticRenderFns } from "./BaseFormWrapper.vue?vue&type=template&id=7259d218&scoped=true&"
import script from "./BaseFormWrapper.vue?vue&type=script&lang=js&"
export * from "./BaseFormWrapper.vue?vue&type=script&lang=js&"
import style0 from "./BaseFormWrapper.vue?vue&type=style&index=0&id=7259d218&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7259d218",
  null
  
)

export default component.exports